function ConsultantCases() {
  return <div>Consultant Cases</div>;
}

export default ConsultantCases;
